module.exports = __webpack_public_path__ + "img/90.0f39a3e6.jpg";